module.exports = __webpack_public_path__ + "img/percent.9b1ae261.png";